import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "children"];
import React, { useImperativeHandle, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var Container = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      className = '',
      children
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var container = useRef(null);
  useImperativeHandle(ref, () => ({
    container: container.current
  }), [container]);
  var defaultClassNames = "login-page " + className;
  return /*#__PURE__*/_jsx("div", _extends({
    ref: container,
    className: defaultClassNames
  }, elmProps, {
    children: children
  }));
});
Container.displayName = 'Login.Container';